const readMessage = (value) => {
    if (typeof value === 'string') return value.trim() || null

    if (Array.isArray(value)) {
        const messages = value.map(item => (typeof item === 'string' ? item.trim() : item?.msg)).filter(Boolean)
        return messages.length ? messages.join(' ') : null
    }

    return null
}

/**
 * Reads the message the backend sent, from either a thunk action or its payload.
 *
 * FastAPI returns `detail` as a plain string for app-level errors, but as an
 * array of Pydantic validation objects ({loc, msg, type}) for 422s — both shapes
 * are flattened here so a toast never receives a raw object.
 *
 * @param {Object|string} source - A thunk action (`response`) or just its `payload`
 * @returns {string|null} The message, or null when the payload carries nothing readable
 */
export const readBackendMessage = (source) => {
    //Acepta la acción completa (rechazada o cumplida) o únicamente su payload
    const payload = source?.meta?.requestStatus ? source.payload : source

    return readMessage(payload)
        ?? readMessage(payload?.detail)
        ?? readMessage(payload?.message)
        ?? null
}

/**
 * Normalizes the error payload of a rejected thunk into a single readable string.
 *
 * @param {Object|string} source - The rejected action (`response`) or just its `payload`
 * @param {string} [fallback="Ocurrió un error al procesar la solicitud."] - Message used when the payload carries nothing readable
 * @returns {string} The message sent by the backend, or the fallback
 *
 * @example
 * dispatch(updateUser(data)).then(response => {
 *     if (response.error) toast.error(getErrorMessage(response, 'No se pudo guardar el usuario.'))
 * })
 */
const getErrorMessage = (source, fallback = "Ocurrió un error al procesar la solicitud.") => readBackendMessage(source) ?? fallback

export { getErrorMessage }
export default getErrorMessage
